var Sampler = (function () {
    function Sampler(gl) {
        this.gl = gl;
        this.sampler = this.gl.createSampler();
    }
    ;
    Sampler.prototype.setParameters = function (min_filter, mag_filter, clamp_type) {
        this.gl.samplerParameteri(this.sampler, this.gl.TEXTURE_MAG_FILTER, this.gl[mag_filter]);
        this.gl.samplerParameteri(this.sampler, this.gl.TEXTURE_MIN_FILTER, this.gl[min_filter]);
        this.gl.samplerParameteri(this.sampler, this.gl.TEXTURE_WRAP_R, this.gl[clamp_type]);
        this.gl.samplerParameteri(this.sampler, this.gl.TEXTURE_WRAP_S, this.gl[clamp_type]);
        this.gl.samplerParameteri(this.sampler, this.gl.TEXTURE_WRAP_T, this.gl[clamp_type]);
    };
    ;
    Sampler.prototype.setParametersFromData = function (data) {
        this.gl.samplerParameteri(this.sampler, this.gl.TEXTURE_MAG_FILTER, data.magFilter);
        this.gl.samplerParameteri(this.sampler, this.gl.TEXTURE_MIN_FILTER, data.minFilter);
        this.gl.samplerParameteri(this.sampler, this.gl.TEXTURE_WRAP_S, data.wrapS);
        this.gl.samplerParameteri(this.sampler, this.gl.TEXTURE_WRAP_T, data.wrapT);
    };
    ;
    Sampler.prototype.bindSampler = function (texture_unit) {
        this.gl.bindSampler(texture_unit, this.sampler);
    };
    Sampler.prototype.deleteSampler = function () {
        this.gl.deleteSampler(this.sampler);
    };
    return Sampler;
}());
export { Sampler };
//# sourceMappingURL=sampler.js.map